module.exports = __webpack_public_path__ + "static/FFlintstone-1328ae66b7acfdd6d661db324293a6e8.jpg";